module.exports = __webpack_public_path__ + "img/child.ee2e22e2.jpg";